import type {
  DomainEvent,
  QuestDefinition,
  QuestProgress,
  QuestState,
} from '../../../core/domain/types';

export function dateKey(nowUtc: number): string {
  return new Date(nowUtc).toISOString().slice(0, 10);
}

export function createQuestState(nowUtc: number, definitions: QuestDefinition[]): QuestState {
  return {
    dateKey: dateKey(nowUtc),
    daily: definitions
      .filter((item) => item.kind === 'daily')
      .slice(0, 3)
      .map((item) => ({ questId: item.id, progress: 0, claimed: false })),
    growth: definitions
      .filter((item) => item.kind === 'growth')
      .map((item) => ({ questId: item.id, progress: 0, claimed: false })),
  };
}

function eventCount(event: DomainEvent): number {
  return 'count' in event ? event.count : 1;
}

function advance(
  entries: QuestProgress[],
  event: DomainEvent,
  definitions: Map<string, QuestDefinition>,
): QuestProgress[] {
  return entries.map((entry) => {
    const definition = definitions.get(entry.questId);
    if (!definition || definition.eventType !== event.type || entry.claimed) return entry;
    return { ...entry, progress: Math.min(definition.target, entry.progress + eventCount(event)) };
  });
}

export function applyQuestEvent(
  state: QuestState,
  event: DomainEvent,
  definitions: Map<string, QuestDefinition>,
): QuestState {
  return {
    ...state,
    daily: advance(state.daily, event, definitions),
    growth: advance(state.growth, event, definitions),
  };
}
